// The Quick Play funnel bar replaces the main menu until the manager reaches the
// transfers page for the first time. That "done" flag is stored per league so a
// returning manager keeps the normal menu.
const QUICKPLAY_FUNNEL_KEY_PREFIX = 'quickplayFunnelComplete:';

function buildKey(leagueId) {
    return `${QUICKPLAY_FUNNEL_KEY_PREFIX}${leagueId}`;
}

export function readQuickplayFunnelComplete(leagueId) {
    if (!leagueId) {
        return false;
    }

    try {
        return localStorage.getItem(buildKey(leagueId)) === 'true';
    } catch (error) {
        console.error('Failed to read the Quick Play funnel flag from localStorage', error);
        return false;
    }
}

export function markQuickplayFunnelComplete(leagueId) {
    if (!leagueId) {
        return;
    }

    try {
        localStorage.setItem(buildKey(leagueId), 'true');
    } catch (error) {
        console.error('Failed to save the Quick Play funnel flag to localStorage', error);
    }
}

export { QUICKPLAY_FUNNEL_KEY_PREFIX };
